export default __webpack_public_path__ + "static/media/StartQuizButton.bcfbeca9.png";